export default __webpack_public_path__ + "static/media/avatar_whitney3.aef7c92b.mp3";